export default class PISetFacade {
  constructor(position) {
    this.position = position;
  }


  listInstructions() {
    const instructions = this.position.selectedRole.instructions
        .listInstructions()
        .map(instruction => {
          instruction.partOfRole = true;
          return instruction;
        });
    for (const instruction of this.position.customInstructions.listInstructions()) {
      const exists = instructions.some(existing => instruction.name === existing.name);
      instruction.partOfRole = false;
      if (!exists) instructions.push(instruction);
    }
    return instructions;
  }

  get passingDirectness() {
    return this.position.selectedRole.instructions?.passingDirectness || this.position.customInstructions?.passingDirectness || 0;
  }

  get pressingIntensity() {
    return this.position.selectedRole.instructions?.pressingIntensity || this.position.customInstructions?.pressingIntensity || 0;
  }

  get attackingWidth() {
    return this.position.selectedRole.instructions?.attackingWidth || this.position.customInstructions?.attackingWidth || 0;
  }

  get movement() {
    return this.position.selectedRole.instructions?.movement || this.position.customInstructions?.movement || 0;
  }

  get dribbling() {
    return this.position.selectedRole.instructions?.dribbling || this.position.customInstructions?.dribbling || 0;
  }

  get passingRisks() {
    return this.position.selectedRole.instructions?.passingRisks || this.position.customInstructions?.passingRisks || 0;
  }

  get crossingFrequency() {
    return this.position.selectedRole.instructions?.crossingFrequency || this.position.customInstructions?.crossingFrequency || 0;
  }

  get crossingPosition() {
    return this.position.selectedRole.instructions?.crossingPosition || this.position.customInstructions?.crossingPosition || 0;
  }

  get creativeFreedom() {
    return this.position.selectedRole.instructions?.creativeFreedom || this.position.customInstructions?.creativeFreedom || 0;
  }

  get shooting() {
    return this.position.selectedRole.instructions?.shooting || this.position.customInstructions?.shooting || 0;
  }

  get marking() {
    return this.position.selectedRole.instructions?.marking || this.position.customInstructions?.marking || 0;
  }

  get tackling() {
    return this.position.selectedRole.instructions?.tackling || this.position.customInstructions?.tackling || 0;
  }

  get lateralDribbling() {
    return this.position.selectedRole.instructions?.lateralDribbling || this.position.customInstructions?.lateralDribbling || 0;
  }

  get holdUpBall() {
    return this.position.selectedRole.instructions?.holdUpBall || this.position.customInstructions?.holdUpBall || 0;
  }

  get makeMoreSurgingForwardRuns() {
    return this.position.selectedRole.instructions?.makeMoreSurgingForwardRuns || 0;
  }

  get makeMoreDartingRuns() {
    return this.position.selectedRole.instructions?.makeMoreDartingRuns || 0;
  }

  get dropDeepMore() {
    return this.position.selectedRole.instructions?.dropDeepMore || 0;
  }

  get getFurtherForward() {
    return this.position.selectedRole.instructions?.getFurtherForward || this.position.customInstructions?.getFurtherForward || 0;
  }

  get sitOffFromDeep() {
    return this.position.selectedRole.instructions?.sitOffFromDeep || 0;
  }

  get carryTheBallMore() {
    return this.position.selectedRole.instructions?.carryTheBallMore || 0;
  }

  get useMoreTacticalDiscipline() {
    return this.position.selectedRole.instructions?.useMoreTacticalDiscipline || 0;
  }

  get collectTheBallMore() {
    return this.position.selectedRole.instructions?.collectTheBallMore || 0;
  }

  get trackBackMore() {
    return this.position.selectedRole.instructions?.trackBackMore || 0;
  }

  get makeMoreDisciplinedMovement() {
    return this.position.selectedRole.instructions?.makeMoreDisciplinedMovement || 0;
  }

  get makeMoreDribblesIntoChannels() {
    return this.position.selectedRole.instructions?.makeMoreDribblesIntoChannels || 0;
  }

  get makeMoreRoamingMovementLaterally() {
    return this.position.selectedRole.instructions?.makeMoreRoamingMovementLaterally || 0;
  }

  get focusPlay() {
    return this.position.selectedRole.instructions?.focusPlay || 0;
  }

  get shootMoreOftenInPenaltyBox() {
    return this.position.selectedRole.instructions?.shootMoreOftenInPenaltyBox || 0;
  }

  get moveIntoCentralDefenceInPossession() {
    return this.position.selectedRole.instructions?.moveIntoCentralDefenceInPossession || 0;
  }

  get moveIntoCentralMidfieldInPossession() {
    return this.position.selectedRole.instructions?.moveIntoCentralMidfieldInPossession || 0;
  }
}
